import React from 'react';
import './CompetitionLink.css';

/**
 * Renders a competition name as a clickable link if URL is available
 * @param {Object} props
 * @param {string} props.competition - Competition name
 * @param {string} props.competitionUrl - Competition URL (optional)
 * @param {string} props.className - Additional CSS class (optional)
 */
const CompetitionLink = ({ competition, competitionUrl, className = '' }) => {
    if (!competition) return '-';

    if (competitionUrl) {
        return (
            <a
                href={competitionUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={`competition-link ${className}`}
                title={`View ${competition} details`}
            >
                {competition}
            </a>
        );
    }

    return <span className={className}>{competition}</span>;
};

export default CompetitionLink;
